const deutsch = (iso: string) => {
  const [jahr, monat, tag] = iso.slice(0, 10).split('-');
  return jahr && monat && tag ? `${tag}.${monat}.${jahr}` : iso;
};

/**
 * Ein unterrichtsfreier Zeitraum in Worten: „am 25.12.2026“ oder „vom 02.07.2026 bis
 * 12.08.2026“, jährlich wiederkehrende ohne Jahr. Die Liste zeigte bisher nur den
 * Titel — die Daten selbst sah man nicht (T-0268).
 */
export function zeitraumText(von: string, bis: string | null | undefined, jaehrlich: boolean): string {
  const fmt = (iso: string) => (jaehrlich ? deutsch(iso).slice(0, 6) : deutsch(iso));
  const text = !bis || von.slice(0, 10) === bis.slice(0, 10) ? `am ${fmt(von)}` : `vom ${fmt(von)} bis ${fmt(bis)}`;
  return jaehrlich ? `jährlich ${text}` : text;
}
